"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("block/base"));

var _react = babelHelpers.interopRequireDefault(require("react"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _VideoPlayer = babelHelpers.interopRequireDefault(require("VideoPlayer"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _userProfile = require("user-profile");

var _LoginForm = require("components/LoginForm");

var _eventDispatcher = babelHelpers.interopRequireDefault(require("event-dispatcher"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var VideoHeaderBlock = (_class = (_temp =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(VideoHeaderBlock, _Block);

  function VideoHeaderBlock() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, VideoHeaderBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(VideoHeaderBlock)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "header", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "videoProps", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "hasVideo", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "content", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(VideoHeaderBlock, [{
    key: "getChildren",
    value: function getChildren() {
      return _react.default.createElement("div", {
        className: "inner-content"
      }, _react.default.createElement("div", {
        className: "container video-container"
      }, this.hasVideo && _react.default.createElement(_VideoPlayer.default, {
        lazy: this.videoProps
      })), _react.default.createElement("div", {
        className: "container body-container",
        dangerouslySetInnerHTML: {
          __html: this.content
        }
      }));
    }
  }]);
  return VideoHeaderBlock;
}(_base.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "header", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "videoProps", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "hasVideo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = VideoHeaderBlock;